import { render, staticRenderFns } from "./UISwitch.vue?vue&type=template&id=7a06ac5b&scoped=true"
import script from "./UISwitch.vue?vue&type=script&lang=js"
export * from "./UISwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a06ac5b",
  null
  
)

export default component.exports